/* src/app/shared/dialog/filters-dialog/filters-dialog.component.scss */
::ng-deep .mat-dialog-container {
  border-radius: 20px;
}
.container {
  display: flex;
  width: 600px;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  border-radius: 20px;
  background: #FFF;
}
.margin-right {
  margin-right: auto;
}
.title {
  color: #001A33;
  font: 700 16px FranceTV Brown;
  line-height: normal;
}
.horizontal-separator {
  height: 1px;
  background-color: #DFEBF7;
  height: 1px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
}
.filter-selection {
  width: 600px;
  border-radius: 5px;
  border: 1px solid #DFEBF7;
  height: 55px;
}
.filter-hour {
  width: 30px;
  border-radius: 5px;
  height: 55px;
}
.label {
  color: #6B90B3;
  font: 400 15px FranceTV Brown;
  line-height: normal;
  margin-left: 10px;
}
.input-value {
  color: #244666;
  font: 400 15px FranceTV Brown;
  line-height: normal;
  margin-left: 10px;
}
.action-button {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}
.small-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  margin-left: 5px;
}
.margin-top {
  margin-top: 25px;
}
.input-hour {
  width: 20px;
}
.action-button-check-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.filters-form-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.operator-value-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
/*# sourceMappingURL=filters-dialog.component.css.map */
